<template>
	<div class="item-edit">
		<div>
			<span class="font-weight-extra-bold">Name:</span>
			{{ salutation }} {{ user.firstName }} {{ user.lastName }}
		</div>
		<div>
			<span class="font-weight-extra-bold">Mobilnummer:</span>
			{{ user.phone | phone }}
		</div>
	</div>
</template>

<script>
import {mapState} from "vuex";
import {getLabel} from "@/helper/form/Salutation";

export default {

	props: {
		user: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
		salutation ()
		{
			return getLabel(this.user.salutation);
		},
	}
}
</script>
